// import { ipcRenderer } from 'electron'
// import isElectron from 'is-electron'
import { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import KBoard from 'k-board-js-api'
import { updatedDiff } from 'deep-object-diff'
import isEmpty from 'lodash.isempty'
import debounce from 'lodash.debounce'

import buildMessage from './presetBuilding'
import getMidiPorts from './getMidiPorts'

import {
  networkStatus,
  deviceConnection,
  refreshThruPorts
} from '../../actions/'

class KBoardListener extends Component {
  kBoard = null
  debouncedUpdate = null

  componentDidMount() {
    // set modal root
    ReactModal.setAppElement('#root')

    try {
      navigator.requestMIDIAccess({sysex: true}).then(access => {
        this.kBoard = new KBoard(access, false)
        // set global reference to kBoard
        window.kBoard = this.kBoard

        //: Midi Thru
        window.midithruports = [{ value: 'none', label: 'None' }]
        // listen for new ports
        access.addEventListener('statechange', (e) => {
          if (e.port.type === 'input') return
          // update port collection
          window.midithruports = getMidiPorts(access, this.props.onRefreshThruPorts)
        })

        // setup device message listeners
        // : connect
        this.kBoard.on('connect', (connectionType) => {
          console.log('EBBC K-Board connect..');
          switch (connectionType) {
            case 'primary':
              this.props.onConnection('connected')
              break;
            case 'secondary':
              this.props.onConnection('connected')
              break;
            case 'reconnect':
              this.props.onReconnection('reconnected')
              break;
            default:

          }
          /*
          if(isElectron()){
            ipcRenderer.send('menu-update-firmware', {
              enabled: true
            });
            ipcRenderer.send('menu-send-preset', {
              enabled: true
            });
           }
           */
        })

        // : disconnection
        this.kBoard.on('disconnect', () => {
          console.log('EBBC K-Board disconnect');
          this.props.onDisconnection(this.props.updatingFirmware ? 'updatingfirmware' : 'disconnected')
          /*
          if(isElectron()){
            ipcRenderer.send('menu-update-firmware', {
              enabled: true
            });
            ipcRenderer.send('menu-send-preset', {
              enabled: true
            });
           }
           */
        })

        // firmware updating
        this.kBoard.on('firmwareupdatecomplete', () => {
          /*
          if(isElectron()){
            ipcRenderer.send('menu-update-firmware', {
              enabled: true
            });
            ipcRenderer.send('menu-send-preset', {
              enabled: true
            });
           }
           */
        })

        // app updating
        /*
        if(isElectron()){
          ipcRenderer.on('download-progress', (progress) => {
            console.log(`>> Updating Editor: ${parseInt(progress * 100)}%`)
          })
         }
        */

        // MIDI Thru
        this.kBoard.on('midi', async (data) => {
          // midi thru
          try {
            if (window.kboardthru && this.props.midithruport !== 'none') {
              if (window.kboardthru.connection === 'closed') {
                await window.kboardthru.open()
              }
              window.kboardthru.send(data)
            }
          } catch (e) {
            console.error('>> K-Board Editor: unable to connect to Thru port', e)
          }
        })

      })
    } catch(e) {
      console.warn('>> Web MIDI API is unsupported in this browser');
      alert("This browser doesn't currently support WebMIDI, please use Chrome, Opera, or Brave")
    }

    this.debouncedUpdate = debounce((currentPreset) => {
      const preset = buildMessage(currentPreset)
      // send device param update
      this.kBoard.sendPreset(preset)
    }, 500, {
      'leading': false,
      'trailing': true
    })
  }

  componentDidUpdate(previousProps) {
    const difference = updatedDiff(previousProps.currentPreset, this.props.currentPreset)

    if(!isEmpty(difference) && Object.keys(difference).length === 1) { // if diff > 1; entire preset, ignore
      if(this.kBoard && this.kBoard.isConnected()){
        // only send preset updates every 500ms at most
        this.debouncedUpdate(this.props.currentPreset)
      } else {
        if(!global.globalThis._debug) console.clear()
        console.warn(`>> cannot update ${Object.keys(difference)} on K-Board, device not connected`)
      }
    } else {
      // this also triggers on editor state changes like toggle bar gain mode
      // maybe this can trigger some action for preset change?
      // console.log('>> editor: currentPreset change');
    }
    // update online status
    this.props.onSetNetworkStatus()
  }

  componentWillUnmount() {
    try {
      // cleanup event handlers
      this.kBoard && this.kBoard.removeAllListeners()
    } catch(err) {
        console.warn('>> something went wrong');
    }
  }

  render() {
    return null
  }
}

const mapStateToProps = (state) => {
  return {
    currentPreset: state.currentPreset
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetNetworkStatus: () => dispatch(networkStatus()),
    // set connection status
    onConnection: (status) => dispatch(deviceConnection(status)),
    // { onConnection : deviceConnection }
    onDisconnection: (status) => dispatch(deviceConnection(status)),
    // { onDisconnection : deviceConnection }
    onReconnection: (status) => dispatch(deviceConnection('reconnected')),
    // { onReconnection : deviceConnection }
    onRefreshThruPorts: () => dispatch(refreshThruPorts())
    // { onRefreshThruPorts : refreshThruPorts }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(KBoardListener)
